import React from 'react';
import { X } from 'lucide-react';
import GenericModal from 'components/modals/GenericModal';

const CancelSubscriptionModal = ({ isOpen, onClose, onCancel, loading }) => {
  if (!isOpen) return null;
  return (
    <GenericModal
      isOpen={isOpen}
      toggle={onClose}
      title="Cancelar Suscripción"
      closable
      width="400px"
      showLogo={false}
      contentPadding="0 2.5rem 2rem 2.5rem"
      showSubmitButton
      showCloseButton
      onSubmit={onCancel}
      onClose={onClose}
      isSubmitting={loading}
      submitButtonText={loading ? 'Cancelando...' : 'Confirmar Cancelación'}
      closeButtonText="Cancelar"
    >
      <div className="space-y-4">
        <p className="text-white/80">
          ¿Estás seguro que quieres cancelar tu suscripción?
        </p>
        <div className="backdrop-blur-md bg-white/10 border border-white/20 p-3 rounded-lg">
          <ul className="mt-2 space-y-2">
            <li className="flex items-start gap-2">
              <X className="w-4 h-4 text-red-400 mt-0.5 flex-shrink-0" />
              <span className="text-white/80">Perderás acceso a todas las funciones premium inmediatamente</span>
            </li>
            <li className="flex items-start gap-2">
              <X className="w-4 h-4 text-red-400 mt-0.5 flex-shrink-0" />
              <span className="text-white/80">No se te realizarán más cobros</span>
            </li>
            <li className="flex items-start gap-2">
              <X className="w-4 h-4 text-red-400 mt-0.5 flex-shrink-0" />
              <span className="text-white/80">No hay reembolsos por el período actual</span>
            </li>
          </ul>
          <p className="mt-3 text-sm italic text-white/60">
            Puedes volver a suscribirte en cualquier momento.
          </p>
        </div>
      </div>
    </GenericModal>
  );
};

export default CancelSubscriptionModal; 